import { useMenuStore } from './store';

export type { MenuItem } from './types/menuItem';
export { useMenu } from './useMenu';

export const menu = {
  install() {
    useMenuStore();
  },
};
